<script setup lang="ts">
import { SuiToggle } from '@developers/scoro-ui';
import { computed } from 'vue';

export type IntegrationsModuleToggleProps = {
	id: string;
	label: string;
	modelValue: boolean;
	disabled?: boolean;
	size?: 'small' | 'medium' | 'large';
	onToggle?: (value: boolean) => void;
};

const props = withDefaults(defineProps<IntegrationsModuleToggleProps>(), {
	disabled: false,
	onToggle: undefined,
	size: 'medium',
});

const emit = defineEmits<{
	(event: 'update:modelValue', value: boolean): void;
}>();

const onUpdate = (value: boolean) => {
	props.onToggle?.(value);
	emit('update:modelValue', value);
};

const toggleSize = computed(() => {
	if (props.size === 'small') {
		return 'medium';
	}

	return props.size;
});
</script>

<template>
	<div class="integrations-module-toggle">
		<SuiToggle
			:id="id"
			:model-value="modelValue"
			:label="label"
			:disabled="disabled"
			:size="toggleSize"
			@update:model-value="onUpdate"
		/>
	</div>
</template>

<style scoped>
.integrations-module-toggle {
	display: inline-flex;
	align-items: center;
}
</style>
